import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import './RiskCompany.css'; // Import the CSS file
import LockTwoToneIcon from "@mui/icons-material/LockTwoTone"; // Import lock icon from react-icons

function RiskCompany() {
  const [data, setData] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { cin } = location.state;

  useEffect(() => {
    // Fetch data from API
    axios
      .get(`https://nexensus.club/cbi/company/riskScores?cin=${cin}`)
      .then((response) => {
        setData(response.data);
        console.log("cin taken in is :", cin);
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  }, [cin]);

  if (!data) return <div>Loading...</div>;

  const ratio = data.ratio[0];

  const handleLockClick = () => {
    navigate('/pricing');
  };

  return (
    <div className="risk-company-container">
      <h1 className="company-name">{data.name}</h1>
      <div className="table-container">
        <h2 className="section-title">Company Scores</h2>
        <table className="company-table">
          <thead>
            <tr>
              <th>Score Type</th>
              <th>Score</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Altman Z Score</td>
              <td>{ratio.zscore ?? 'N/A'}</td>
              <td>Determining whether a company, notably in the manufacturing space, is headed for bankruptcy</td>
            </tr>
            <tr>
              <td>Piotroski F Score</td>
              <td>{ratio.fscore ?? 'N/A'}</td>
              <td>a number between 0 and 9 which is used to assess strength of company's financial position</td>
            </tr>
            <tr>
              <td>Beneish M Score Model</td>
              <td>{ratio.mscore ?? 'N/A'}</td>
              <td>a mathematical model that uses financial ratios and eight variables to identify whether a company has manipulated its earnings</td>
            </tr>
          </tbody>
        </table>
      </div>
      <h2 className="section-title">Company Parameters</h2>
      <div className="table-container">
        
        <table className="company-table blurred">
          <thead>
            <tr>
              <th>Parameter</th>
              <th>Score</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Constitution</td>
              <td>9</td>
              <td>10</td>
            </tr>
            <tr>
              <td>Board Quality</td>
              <td>11</td>
              <td>12</td>
            </tr>
            <tr>
              <td>Change in Key Management Personnel</td>
              <td>13</td>
              <td>14</td>
            </tr>
            <tr>
              <td>Board member linked to Bank/NBFC</td>
              <td>15</td>
              <td>16</td>
            </tr>
            <tr>
              <td>Product/Market Concentration</td>
              <td>17</td>
              <td>18</td>
            </tr>
          </tbody>
        </table>
        <div className="lock-overlay" onClick={handleLockClick}>
        <LockTwoToneIcon className="lock-icon " />
        </div>
      </div>
    </div>
  );
}

export default RiskCompany;
